import React from "react";
import {
  AiFillGithub,
  AiFillLinkedin,
  AiOutlineTwitter,
  AiOutlineMail,
} from "react-icons/ai";

const Footer = () => {
  const dateTime = new Date().getFullYear();
  return (
    <footer className="bg-[#2D2E32] text-white pt-20 px-6 md:px-12 lg:px-2">
      <div className="lg:max-w-[1200px] mx-auto">
        <div className="flex flex-col md:flex-row justify-between gap-16">
          <div>
            <h2 className="text-xl font-bold tracking-[.08em]">
              BIKASH DEVSHARMA
            </h2>
            <p className="mt-8 text-justify">
              Passionate Front-end Developer crafting engaging web experiences.{" "}
              <br /> Let's build the web together.
            </p>
          </div>
          <div>
            <h2 className="text-xl font-bold">SOCIAL</h2>
            <div className=" flex  gap-5 items-center py-3">
              <a
                href="https://github.com/Bikash-Dev-Bk"
                target="_blank"
                rel="noreferrer"
              >
                <AiFillGithub className="text-3xl  " />
              </a>
              <a
                href="https://www.linkedin.com/in/bikash-devsharma/"
                target="_blank"
                rel="noreferrer"
              >
                <AiFillLinkedin className="text-3xl  " />
              </a>
              <a
                href="https://twitter.com/BikashDevSharma"
                target="_blank"
                rel="noreferrer"
              >
                <AiOutlineTwitter className="text-3xl  " />
              </a>
              <a
                href="mailto:bikashdevsharma99@gmail.com"
                target="_blank"
                rel="noreferrer"
              >
                <AiOutlineMail className="text-3xl  " />
              </a>
            </div>
          </div>
        </div>
        <div className="mt-16">
          <hr className="bg-white hx" />
          <p className="text-center py-10">
            <small>
              &copy; Copyright {dateTime}. Made by{" "}
              <a
                href="https://www.linkedin.com/in/bikash-devsharma/"
                target="_blank"
                rel="noreferrer"
                className="underline  "
              >
                Bikash Devsharma
              </a>
            </small>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
